import React from 'react'

import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'

import TextField from '@mui/material/TextField';

import {
  useNavigate
} from "react-router-dom";

export default function Login() {

  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')

  const navigate = useNavigate('')

  const handleFirstnameFilter = (event) => {
    setEmail(event.target.value);
  }

  const handleLastnameFilter = (event) => {
    setPassword(event.target.value);
  }

  const handleEnterKey = (event) => {

    if (event.key==='Enter') {
      handleLogin()
    }
  }

  const handleLogin = async () => {
    let login_details = {
      login_email: `${email}`,
      login_password: `${password}`
    }

    if (email === "" || password === "") {
      console.error("Invalid Login")
      return;
    }

    try {
      // https://ic360portalbackend.azurewebsites.net
      const response = await fetch('https://ic360portalbackend.azurewebsites.net/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-type': 'application/JSON',
        },
        body: JSON.stringify({login_details}),
        credentials: "include"
      })

      const data = await response.json();
      if (response.status === 200 && data.status === "Login successful") {
        navigate('/');
      } else if (response.status === 400 && data.error === "Invalid Login") {
        alert("Invalid Login");
      } else {
        alert(data.error || "Unknown error occurred");
      }

    } catch (error) {
      console.error(error);
    }
  }

  const gotoUserRegister = () => {
    navigate('/userRegister');
  }

  return (    
  <>
    <Navbar/>
    <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="user-access-wrapper">
        <div className="login-box">
          <div className="page-title">Login</div>
          <div className="device-search-wrapper">
            <TextField
              id="standard-search-email"
              label="Email"
              variant="standard"
              color='error'
              value = {email}
              onChange={handleFirstnameFilter}
            />
          </div>
          <div className="device-search-wrapper">
            <TextField
              id="standard-search-password"
              label="Password"
              variant="standard"
              color='error'
              value = {password}
              onChange={handleLastnameFilter}
              type='password'
              onKeyDown={handleEnterKey}
            />
          </div>

          <div className="device-buttons-bar device-filter-bar">
            <div className="login-button" onClick={handleLogin} data-testid="login-button">Login</div>
          </div>

          <div className="login-redirect-box">
            <div className="">Don't have an account? <span className="login-help" onClick={gotoUserRegister}>Sign Up</span></div>
          </div>

        </div>

      </div>
    
    <Footer/>
    </div>
  </>
  )
}
